import Swiper from 'swiper';
import {
    Navigation,
    A11y,
    EffectFade,
    EffectFlip,
    Thumbs
} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/a11y';
import 'swiper/css/effect-fade';
import 'swiper/css/effect-flip';

document.querySelectorAll('.swiper-signposting').forEach(function (thisSlider) {
    const id = thisSlider.id; // make sure your slider element has a unique ID
    const slider = document.getElementById(id);
    const container = slider.parentElement;

    const swiper = new Swiper(slider, {
        modules: [Navigation, A11y],
        a11y: {
            enabled: true
        },
        navigation: {
            nextEl: container.querySelector('.swiperSignpostingNext'),
            prevEl: container.querySelector('.swiperSignpostingPrev'),
        },
        breakpoints: {
            0: {
                slidesPerView: 1.2,
                spaceBetween: 16,
            },
            576: {
                slidesPerView: 2.2,
                spaceBetween: 16,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 16,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 16,
            },
        },
    });
});

document.querySelectorAll('.related .swiper-related').forEach(function (thisSlider) {
    const id = thisSlider.id; // make sure your slider element has a unique ID
    const slider = document.getElementById(id);
    const container = slider.closest('.related');

    const swiper = new Swiper(slider, {
        modules: [Navigation, A11y],
        a11y: {
            enabled: true
        },
        navigation: {
            nextEl: container.querySelector('.swiperRelatedNext'),
            prevEl: container.querySelector('.swiperRelatedPrev'),
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 16,
            },
            576: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 16,
            },
        },
    });
});

// The slider within a slide
document.querySelectorAll('.related-item .swiper-related-gallery').forEach(function (thisSlider) {
    const id = thisSlider.id; // make sure your slider element has a unique ID
    const slider = document.getElementById(id);
    const container = slider.closest('.related-item');

    const swiper = new Swiper(slider, {
        modules: [Navigation, A11y, EffectFade],
        a11y: {
            enabled: true
        },
        navigation: {
            nextEl: container.querySelector('.swiperRelatedGalleryNext'),
            prevEl: container.querySelector('.swiperRelatedGalleryPrev'),
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        slidesPerView: 1,
        spaceBetween: 0,
    });
});

document.querySelectorAll('.quote-slider .swiper-quote').forEach(function (thisSlider) {
    const id = thisSlider.id; // make sure your slider element has a unique ID
    const slider = document.getElementById(id);
    const container = slider.closest('.quote-slider');

    const swiper = new Swiper(slider, {
        modules: [Navigation, A11y],
        a11y: {
            enabled: true
        },
        navigation: {
            nextEl: container.querySelector('.swiperQuoteNext'),
            prevEl: container.querySelector('.swiperQuotePrev'),
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
        },
    });
});

// document.querySelectorAll('.listing-map-slider .swiper-listing').forEach(function (thisSlider) {
//     const id = thisSlider.id; // make sure your slider element has a unique ID
//     const slider = document.getElementById(id);
//     const container = slider.closest(".listing-map-slider");

//     const swiper = new Swiper(slider, {
//         modules: [Navigation, A11y],
//         a11y: {
//             enabled: true
//         },
//         // navigation: {
//         //     nextEl: container.querySelector('.swiperListingNext'),
//         //     prevEl: container.querySelector('.swiperListingPrev'),
//         // },
//         breakpoints: {
//             0: {
//                 slidesPerView: 1,
//             },
//         },
//     });
// });

document.querySelectorAll('.buying-options .swiper-buying-options').forEach(function (thisSlider) {
    const id = thisSlider.id; // make sure your slider element has a unique ID
    const slider = document.getElementById(id);
    const container = slider.closest('.buying-options');

    const swiper = new Swiper(slider, {
        modules: [Navigation, A11y],
        a11y: {
            enabled: true
        },
        navigation: {
            nextEl: container.querySelector('.swiperBuyingOptionsNext'),
            prevEl: container.querySelector('.swiperBuyingOptionsPrev'),
        },
        breakpoints: {
            0: {
                slidesPerView: 1.1,
                spaceBetween: 16,
            },
            576: {
                slidesPerView: 2.1,
                spaceBetween: 16,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 16,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 16,
            },
        },
    });
});

function gallerySlider() {
    document.querySelectorAll('.media-gallery .swiper-media-gallery').forEach(function (thisSlider) {
        const id = thisSlider.id; // make sure your slider element has a unique ID
        const slider = document.getElementById(id);
        const container = slider.closest('.media-gallery');

        const swiper = new Swiper(slider, {
            modules: [Navigation, A11y],
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 16,
            a11y: {
                enabled: true
            },
            breakpoints: {
                0: {
                    navigation: {
                        nextEl: container.querySelector('.swiperMediaGalleryMobileNext'),
                        prevEl: container.querySelector('.swiperMediaGalleryMobilePrev'),
                    },
                },
                992: {
                    navigation: {
                        nextEl: container.querySelector('.swiperMediaGalleryNext'),
                        prevEl: container.querySelector('.swiperMediaGalleryPrev'),
                    },
                }
            }
        });
    });
};

gallerySlider();

// We are initiating this slider differently because there are two sets of buttons for mobile vs desktop placement
$(window).on('resize', function () {
    gallerySlider();
});

document.querySelectorAll(".banner-slider").forEach(function (thisBanner) {
  const mainId = thisBanner.querySelector(".swiper-banner-main").id;
  const topId = thisBanner.querySelector(".swiper-banner-top").id;
  const bottomId = thisBanner.querySelector(".swiper-banner-bottom").id;
  const mainSlider = document.getElementById(mainId);
  const topSlider = document.getElementById(topId);
  const bottomSlider = document.getElementById(bottomId);
  const container = thisBanner;

  const options = {
    modules: [Navigation, A11y, EffectFade],
    a11y: {
      enabled: true,
    },
    loop: true,
    effect: "fade",
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      992: {
        allowTouchMove: false,
      },
    },
  };

  const swiperTop = new Swiper(topSlider, {
    ...options,
  });

  const swiperBottom = new Swiper(bottomSlider, {
    ...options,
  });

  const swiper = new Swiper(mainSlider, {
    ...options,
    navigation: {
      nextEl: container.querySelector(".swiperBannerNext"),
      prevEl: container.querySelector(".swiperBannerPrev"),
    },
    on: {
      realIndexChange: function ({ realIndex }) {
        swiperTop.slideTo(realIndex);
        swiperBottom.slideTo(realIndex);
      },
    },
  });
});

// Popup slider for banner slider
$(".bannerSliderPopup").magnificPopup({
  type: "image",
  gallery: {
    enabled: true,
  },
});